import { Component, OnInit, Inject, forwardRef } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'left-jacket',
  templateUrl: './left-jacket.component.html',
  styleUrls: ['./left-jacket.component.css']
})
export class LeftJacketComponent implements OnInit {

   constructor(@Inject(forwardRef(() => AppComponent)) public parent : AppComponent) {
   }
  
  ngOnInit() {
    this.parent.applyDesignOnJacket();
  }

}



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/left-jacket/left-jacket.component.ts